module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-company/03-47b70c2015d945f30548cb26dadb04f6.png";